import type { ExportBundle } from '@voicer/shared';
import { ws } from '../ws/client';
import { download } from './Dashboard';

/** Download the current chat + settings + profiles as a v2 JSON backup. */
export async function exportBackup() {
  const b = await ws.rpc<ExportBundle>('context.export');
  const name = (b.session.session.name || 'chat').replace(/\W+/g, '_');
  download(`voicer-${name}.json`, JSON.stringify(b, null, 2));
  return b;
}

/** Pick a backup JSON file and import it. `new` creates a session; `merge` folds into the current one. */
export function importBackup(mode: 'new' | 'merge' = 'new'): Promise<void> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/json,.json';
    input.onchange = async () => {
      const f = input.files?.[0];
      if (!f) {
        resolve();
        return;
      }
      try {
        const bundle = JSON.parse(await f.text()) as ExportBundle;
        await ws.rpc('context.import', { bundle, mode });
        resolve();
      } catch (err) {
        reject(err instanceof Error ? err : new Error(String(err)));
      }
    };
    input.click();
  });
}
